import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from "@angular/material/legacy-autocomplete";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyCheckboxModule as MatCheckboxModule } from "@angular/material/legacy-checkbox";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyMenuModule as MatMenuModule } from "@angular/material/legacy-menu";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { MatLegacyRadioModule as MatRadioModule } from "@angular/material/legacy-radio";
import { MatLegacySelectModule as MatSelectModule } from "@angular/material/legacy-select";
import { MatLegacySlideToggleModule as MatSlideToggleModule } from "@angular/material/legacy-slide-toggle";
import { MatLegacyTabsModule as MatTabsModule } from "@angular/material/legacy-tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { RouterModule } from "@angular/router";
import { EffectsModule } from "@ngrx/effects";
import { TranslateModule } from "@ngx-translate/core";
import { SelectModule } from "@obg/core.select";
import { DialogLayoutModule, MatCoreModule, OverlaySpinnerModule } from "@obg/mat.ui.core";
import { MatGlobalModule } from "@obg/mat.ui.global";
import { CoreModule, UiInteractionService } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { GlobalModule } from "@obg/ngx.global";
import { RouterModule as NgxRouterModule } from "@obg/ngx.router";
import {
	BannerModule,
	CommonValidationErrorModule,
	CommonValidationRendererModule,
	ProgressBarModule,
	RssFeedModule,
} from "@obg/ngx.ui.common";
import { CompactFooterModule, ComponentFactoryService, CoreUiModule } from "@obg/ngx.ui.core";
import { GlobalUiModule } from "@obg/ngx.ui.global";
import { GlobalUiGlideModule } from "@obg/ngx.ui.global.glide";
import { GlobalUiLazyImageModule } from "@obg/ngx.ui.global.lazy-image";

import { SmartIdLoginVerificationContainer } from "../smart-id-verification/src/container/smart-id-login-verification.container";

import { AnnualDataValidationAlertContainer } from "./annual-data-validation/annual-data-validation-alert/annual-data-validation-alert.container";
import { AnnualDataValidationEditContainer } from "./annual-data-validation/annual-data-validation-edit/annual-data-validation-edit.container";
import { BonusProgressComponent } from "./bonus/bonus-progress/bonus-progress.component";
import { CafFaceAuthenticatorContainer } from "./caf-face-authenticator/caf-face-authenticator.container";
import { CovidMessageContainer } from "./covid-message/covid-message.container";
import { CustomerAssessmentsContainer } from "./customer-assessments/customer-assessments.container";
import { DropdownMenuComponent } from "./dropdown-menu/dropdown-menu.component";
import { EntityLegalNoticeContainer } from "./entity-legal-notice/entity-legal-notice.container";
import { GeofencingAlertPermissionComponent } from "./geofencing/geofencing-alert.permission.component";
import { GeolocationDialogComponent } from "./geofencing/geolocation-dialog/geolocation-dialog.component";
import { WageringBlockDialogContainer } from "./geofencing/wagering-block/wagering-block-dialog.container";
import { AnnualValidationNotificationComponent } from "./header/annual-validation-notification/annual-validation-notification.component";
import { IauiNotificationComponent } from "./header/iaui-notification/iaui-notification.component";
import { KycNotificationComponent } from "./header/kyc-notification/kyc-notification.component";
import { IauiBettingLimitModule } from "./iaui-betting-limit/iaui-betting-limit.module";
import { IauiVerificationModule } from "./iaui-verification/iaui-verification.module";
import { LatestPrivacyPolicyContainer } from "./latest-privacy-policy/latest-privacy-policy.container";
import { MarketingNotificationsComponent } from "./marketing-notifications/marketing-notifications.component";
import { CompleteAccountLoginContainer } from "./migrated-users/complete-account-login/complete-account-login.container";
import { MigratedUserWelcomeContainer } from "./migrated-users/migrated-user-welcome/migrated-user-welcome-container";
import { MigrationNotificationContainer } from "./migration-notification/migration-notification-container";
import { OtpContainer } from "./otp/otp.container";
import { PropMessageModule } from "./prop-message/prop-message.module";
import { PropMessageService } from "./prop-message/prop-message.service";
import { PushMessageDialogComponent } from "./push-message/push-message-dialog/push-message-dialog.component";
import { SessionExpiredAlertEffect } from "./session-expired/session-expired-alert.effect";
import { SessionLimitExpiredAlertContainer } from "./session-limit-expired/session-limit-expired-alert.container";
import { SessionLimitExpiredAlertContainerV2 } from "./session-limit-expired/v2/session-limit-expired-alert-v2.container";
import { ArgentinaRealityCheckSnackBarComponent } from "./snackbar/argentina/argentina-reality-check-snack-bar.component";
import { RealityCheckSnackBarComponent } from "./snackbar/reality-check-snack-bar.component";
import { MAT_COMMON_UI_INTERACTION_TRACKING_MAP } from "./telemetry/ui-interaction-telemetry.const";
import { ContentMenuItemsComponent } from "./user-summary/content-menu-items/content-menu-items.component";
import { FundsOverviewComponent } from "./user-summary/funds-overview/funds-overview.component";
import { TicketCounterComponent } from "./user-summary/ticket-counter/ticket-counter.component";
import { UserSummaryContainer } from "./user-summary/user-summary.container";

export const MAT_COMMON_UI_DIRECTIVES: any[] = [
	BonusProgressComponent,
	DropdownMenuComponent,
	CustomerAssessmentsContainer,
	LatestPrivacyPolicyContainer,
	EntityLegalNoticeContainer,
	CovidMessageContainer,
	MarketingNotificationsComponent,
	CompleteAccountLoginContainer,
	ContentMenuItemsComponent,
	FundsOverviewComponent,
	TicketCounterComponent,
	UserSummaryContainer,
	IauiNotificationComponent,
	RealityCheckSnackBarComponent,
	AnnualValidationNotificationComponent,
	KycNotificationComponent,
	ArgentinaRealityCheckSnackBarComponent,
	SessionLimitExpiredAlertContainer,
	SessionLimitExpiredAlertContainerV2,
	SmartIdLoginVerificationContainer,
	GeofencingAlertPermissionComponent,
	GeolocationDialogComponent,
	PushMessageDialogComponent,
	WageringBlockDialogContainer,
	MigratedUserWelcomeContainer,
	MigrationNotificationContainer,
	CafFaceAuthenticatorContainer,
	OtpContainer,
	AnnualDataValidationAlertContainer,
	AnnualDataValidationEditContainer,
];

export const MAT_ENTRY_COMPONENTS = [
	RealityCheckSnackBarComponent,
	LatestPrivacyPolicyContainer,
	ArgentinaRealityCheckSnackBarComponent,
	SmartIdLoginVerificationContainer,
];

@NgModule({
	imports: [
		EffectsModule.forFeature([SessionExpiredAlertEffect]),
		BannerModule,
		MatIconModule,
		MatDividerModule,
		MatTabsModule,
		CommonModule,
		CommonValidationErrorModule,
		CoreContentModule,
		CoreModule,
		CoreUiModule,
		DialogLayoutModule,
		GlobalModule,
		MatCoreModule,
		MatGlobalModule,
		FormsModule,
		ReactiveFormsModule,
		MatProgressSpinnerModule,
		MatAutocompleteModule,
		MatFormFieldModule,
		MatInputModule,
		MatMenuModule,
		MatCheckboxModule,
		MatRadioModule,
		MatSelectModule,
		SelectModule,
		MatSlideToggleModule,
		MatButtonModule,
		RouterModule,
		NgxRouterModule,
		GlobalUiModule,
		GlobalUiGlideModule,
		ProgressBarModule,
		RssFeedModule,
		GlobalUiLazyImageModule,
		IauiBettingLimitModule,
		IauiVerificationModule,
		CompactFooterModule,
		OverlaySpinnerModule,
		PropMessageModule,
		TranslateModule,
		MatToolbarModule,
		CommonValidationRendererModule,
	],
	providers: [PropMessageService],
	exports: [MAT_COMMON_UI_DIRECTIVES],
	declarations: [MAT_COMMON_UI_DIRECTIVES],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MatCommonModule {
	constructor(
		componentFactoryService: ComponentFactoryService,
		resolver: ComponentFactoryResolver,
		uiInteractionService: UiInteractionService
	) {
		componentFactoryService.registerLazyLoadedResolver(resolver, ...MAT_ENTRY_COMPONENTS);
		uiInteractionService.registerTrackingData(MAT_COMMON_UI_INTERACTION_TRACKING_MAP);
	}
}
